module.exports = __webpack_public_path__ + "img/logo-dc.1aaab932.svg";